import { collection } from '@/infra/collection'
import { Id } from '@/infra/id'
import { type BillingApi } from '@/features/billing/api/billing-api'
import { BillingTransaction } from './BillingTransaction'
import { mapBillingTransactionResourceToProps } from './billing-transaction-mappers'

/**
 * Store for billing transactions.
 */
export class TransactionStore {
  /**
   * Billing transactions.
   */
  readonly billingTransactions = collection({
    getDataId: (d) => d.id,
    getModelId: (m) => m.id,
    create: () => new BillingTransaction(),
  })

  constructor(private readonly _api: BillingApi) {}

  /**
   * Gets the loaded billing transactions with the given IDs.
   */
  filterBillingTransactionsByIds(ids: string[]) {
    ids = ids.filter((x) => !isNaN(parseInt(x)))
    return this.billingTransactions.filter((x) => ids.includes(Id.assert(x.id)))
  }

  /**
   * Fetches the billing transactions with the given IDs.
   */
  async fetchBillingTransactions(ids: string[]) {
    ids = ids.filter((x) => !isNaN(parseInt(x)))

    if (ids.length === 0) {
      return []
    }

    const transactions = await this._api.transactions.getMany({ ids })
    return this.billingTransactions.set(
      transactions.map(mapBillingTransactionResourceToProps),
    )
  }
}
